// extracted by mini-css-extract-plugin
module.exports = {"action":"memberDetailsLinkButton_action__UkQTL"};